import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import * as React from 'react';
import '../../../../Divider/index.js';
import { InternalSelectionListItem } from '../../SelectionListItem/components/InternalSelectionListItem/InternalSelectionListItem.js';
import { useSelectionListSection } from '../hooks/useSelectionListSection.js';
import '../../../../Typography/index.js';
import { Divider as DividerMemoized } from '../../../../Divider/Divider.js';
import { Typography } from '../../../../Typography/Typography.js';

var InternalSelectionListSection = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var section = props.section,
    state = props.state;
  var _useSelectionListSect = useSelectionListSection(props),
    itemProps = _useSelectionListSect.itemProps,
    groupProps = _useSelectionListSect.groupProps;
  return /*#__PURE__*/React.createElement(React.Fragment, null, section.key !== state.collection.getFirstKey() && /*#__PURE__*/React.createElement(DividerMemoized, {
    my: "8"
  }), /*#__PURE__*/React.createElement("li", itemProps, section.rendered && /*#__PURE__*/React.createElement(Typography, {
    variant: "body-s-strong",
    textColor: "base.subtle",
    p: "4"
  }, section.rendered), /*#__PURE__*/React.createElement("ul", _extends({
    ref: ref
  }, groupProps), _toConsumableArray(section.childNodes).map(function (node) {
    return /*#__PURE__*/React.createElement(InternalSelectionListItem, {
      key: node.key,
      item: node,
      state: state
    });
  }))));
}));

export { InternalSelectionListSection };
//# sourceMappingURL=InternalSelectionListSection.js.map
